export default __webpack_public_path__ + "static/media/filter.f958c51c.svg";